'use client';

import clsx from 'clsx';
import { RankedKeyword, RankedKeywordShiftEnum } from '~/apis/search';
import { Typography } from '@bgzt/ui';
import IcChangeUp from '~/public/assets/icons/ic_change_up.svg';
import IcChangeDown from '~/public/assets/icons/ic_change_down.svg';
import IcNewBadge from '~/public/assets/icons/ic_new_badge.svg';

import styles from './HomeRankedKeywordItem.module.css';

import globalStyles from '~/styles/utils.module.css';

type Props = {
  rankedKeyword: RankedKeyword;
  onClick?: () => void;
};
export const HomeRankedKeywordItem = ({ rankedKeyword, onClick }: Props) => {
  const renderShift = (shift?: RankedKeywordShiftEnum) => {
    switch (shift) {
      case 'UP':
      case 'NEW':
        return <IcChangeUp />;
      case 'DOWN':
        return <IcChangeDown />;
      case 'NONE':
        return <span className={styles.changeNone} />;
      default:
        return null;
    }
  };
  return (
    <div className={styles.item} onClick={onClick}>
      <Typography variant="L7" color="gray-900" className={styles.order}>
        {rankedKeyword.ranking}
      </Typography>
      <span className={styles.change}>{renderShift(rankedKeyword.shift)}</span>
      <Typography
        variant="L7"
        color="gray-900"
        className={clsx([styles.keyword, globalStyles.singleLineEllipticalText])}
      >
        {rankedKeyword.keyword}
      </Typography>

      {rankedKeyword.shift === 'NEW' && (
        <div className={styles.newBadge}>
          <IcNewBadge />
        </div>
      )}
    </div>
  );
};
